// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.editor_BmuoJ {
    min-height : var(--size-editorMinHeight, 65vh);
    min-width : var(--size-editorMinWidth, 65vw);
    position: relative;
  }
  
  .tab_DhhSy { 
    padding : var( --size-padMedium, 16px );
  }
  
  .grid_E0iHB {
    display : grid;
    grid-template-columns: auto auto;
    column-gap : var( --size-padMedium, 16px );
    row-gap : var( --size-padMedium, 16px );
    align-items: center;
    justify-content: left;
    padding : var( --size-padMedium, 16px );
  }
  
  .fill_q8opg {
    grid-column: 1 / span 2;
  }
  
  .list_Zs8OQ {
    min-width : 240px;
  }`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes/lib/export/shared/ExportEditor.css"],"names":[],"mappings":";AACA;IACI,8CAA8C;IAC9C,4CAA4C;IAC5C,kBAAkB;EACpB;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,cAAc;IACd,gCAAgC;IAChC,0CAA0C;IAC1C,uCAAuC;IACvC,mBAAmB;IACnB,qBAAqB;IACrB,uCAAuC;EACzC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB","sourcesContent":["\n.editor {\n    min-height : var(--size-editorMinHeight, 65vh);\n    min-width : var(--size-editorMinWidth, 65vw);\n    position: relative;\n  }\n  \n  .tab { \n    padding : var( --size-padMedium, 16px );\n  }\n  \n  .grid {\n    display : grid;\n    grid-template-columns: auto auto;\n    column-gap : var( --size-padMedium, 16px );\n    row-gap : var( --size-padMedium, 16px );\n    align-items: center;\n    justify-content: left;\n    padding : var( --size-padMedium, 16px );\n  }\n  \n  .fill {\n    grid-column: 1 / span 2;\n  }\n  \n  .list {\n    min-width : 240px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor": `editor_BmuoJ`,
	"tab": `tab_DhhSy`,
	"grid": `grid_E0iHB`,
	"fill": `fill_q8opg`,
	"list": `list_Zs8OQ`
};
export default ___CSS_LOADER_EXPORT___;
